import React from "react";
import FooterCardSection from "./FooterCardSection";
import FooterSection from "./FooterSection";
import styles from "./Footer.module.css";

const Footer = () => (
  <div className={styles["footer-container"]}>
    <FooterCardSection />
    <FooterSection />
  </div>
);

export default Footer;
